import { DriverOccupation, PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { DriverShortFormValues } from '@acorn-portal/shared/src/utils/initialValues/get-driver-short-form-values';

export const checkIfFullTime = (occupation: DriverOccupation): string => {
	if (occupation?.isPartTime === true) {
		return 'no';
	} else if (occupation?.isPartTime === false) {
		return 'yes';
	}
	return '';
};

/**
 * Generates values to edit the short driver form, specifically for the 30-day subscription journey,
 * typically used for editing proposer driver information.
 *
 * @param data - The driver data object containing occupation and employment details.
 * @returns The structured form values for editing proposer driver information, or `null` if no data is provided.
 */
export const getDriverShortFormValues = (data: PcDriver | null): DriverShortFormValues | null => {
	// Handle conditional values
	if (data && data.driverOccupations?.length) {
		const clonedData = structuredClone(data); // prevent store mutations
		const employmentStatus = checkIfFullTime(clonedData.driverOccupations[0]);
		const otherEmploymentStatus = checkIfFullTime(clonedData.driverOccupations[1]);
		let otherEmployment = 'no';
		const otherOccupationData = clonedData.driverOccupations[1];
		if (otherOccupationData && Object.values(otherOccupationData).some((value) => !!value)) otherEmployment = 'yes';

		// return with the required structure
		return {
			employmentType: clonedData.driverOccupations[0]?.employmentStatus || '', // e.g. code for e.g. employed etc.
			employmentStatus, // is it full time (yes/no)
			occupation: clonedData.driverOccupations[0]?.occupation || '',
			industry: clonedData.driverOccupations[0]?.businessType || '',
			otherEmployment, // this drives the display of the below data
			otherEmploymentType: clonedData.driverOccupations[1]?.employmentStatus || '',
			otherEmploymentStatus, // is it full time (yes/no)
			otherOccupation: clonedData.driverOccupations[1]?.occupation || '',
			otherIndustry: clonedData.driverOccupations[1]?.businessType || '',
		};
	}
	return null;
};
